{
    "Rules_Validation_MustBeANumber": "Doit être un nombre",
    "Rules_Validation_MustBeAnInteger": "Doit être un nombre entier",
    "Rules_Validation_MustBeGreaterThanZero": "Doit être supérieur à zéro",
    "Rules_Validation_EmailMustBeValid": "L'adresse électronique doit être valide",
    "Rules_Validation_MustBeLessThanMaxSafeInteger": "Supérieur à la valeur maximale autorisée",
    "Rules_Validation_MustBeLessThanLimit": "Doit être inférieur à {}",
    "Rules_Validation_MustMatch": "Doit correspondre",
    "Rules_Validation_MinLength": "Doit comporter au moins {} caractères",
    "Rules_Numbers_MaxSafeInteger": "la valeur entière maximale",
    "NAME": "RulesLanguage",
    "Rules_Validation_ValidUrl": "Doit être une URL valide",
    "Rules_Validate_Empty": "Ce champ est obligatoire",
    "Rules_Validation_MaxLength": "Doit comporter au plus {} caractères",
    "Rules_Validation_MaxWordLength": "Chaque mot doit comporter au maximum {} caractères",
    "Rules_Validation_IncorrectPattern": "La valeur fournie n'est pas valide",
    "Rules_Validation_Unique": "La valeur doit être unique",
    "Rules_Validation_ContentType": "Le type de contenu doit être l'un des suivants : {}",
    "Rules_Validation_MustBeUnderLimit": "Doit être inférieur à {}"
}